<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>

            <!-- Vertical layout -->
            <v-row class="d-flex align-center justify-center">
                <v-col><center><img src="/ksatransparent.png" style="width:50px;" /></center><br /><div class="text-center" style="border-bottom:1px dashed #000; color: #000;">{{$t('Total')}}</div><div class="mt-3 text-center" style="color: #000;">{{value.reduce((accumulator, currentItem) => accumulator + currentItem.count, 0)}}</div></v-col>
                <v-col v-for="item in value" :key="item.id" class="text-center">
                    <v-row align="end">

                        <v-col cols="12">

                            <div class="bar-container d-flex flex-column justify-end">
                                <div style="color: #000;">{{ item.percentage }}%</div>
                                <div class="bar"
                                     :style="{
  height: `${item.percentage}%`,
  backgroundColor: '#00bcd4'
}"></div>
                                <div style="font-size:11px;min-height:50px; color: #000;">{{item.municipalityName}}</div>
                            </div>
                        </v-col>
                    </v-row>

                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                orientation: 'horizontal', // Default to horizontal view
            }
        },
    }
</script>

<style scoped>
    .text-truncate {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 70px;
    }
    .bar-container {
        height: 150px;
        width: 70px;
        background-color: transparent;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .logocontainer{
        border:1px solid #c3c3c3;
        width:50px;
        height:50px;
        padding:5px;
        border-radius:5px;
    }
    .bar {
        width: 100%;
    }
</style>
